import React from "react";
import { RouterProvider } from "react-router-dom";

import routes from "./routes/routes";
import "./app.css";


const App = () => {
  return <RouterProvider router={routes} />;
};

export default App;
